<template>
    <div class="container">
    <b-card no-body class="overflow-hidden" style="max-width: 950px;">
    <b-row no-gutters>
        <b-col md="6">
        <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="800"
                controls
                indicators
                background= "#ababab"
                img-width="720"
                img-height="720"
                style="text-shadow: 1px 1px 2px #a12;"
                no-animation
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
                >
                        <b-carousel-slide
                        v-for="(item, index) in articulo" :key="index" v-bind:id="index"
                        :img-src="'https://michi.controlador-aula.com/ima/'+item.nombre_ima"
                        >
                        </b-carousel-slide>
                    </b-carousel>
      </b-col>

      <b-col md="6">
        <b-card-body>
          <b-card-text>
            <h1>{{articulo[0].nombre_art}}</h1>
                <div v-html="articulo[0].descripcionLar_art"></div>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'articulo',
    data () {
    return {
      articulo: [
          {articulo: '',
           descripcionLar_art: '' }
      ]
    }
  },
  async created (state) {
    try {
      const res = await axios.get(`https://michi.controlador-aula.com/Connections/michi-jala-8695JA-a.php?x=${this.$route.params.id}`)
      this.articulo = res.data
      console.log("prueba"+this.articulo)
    } catch (error) {
      console.log(error)
      return { error }
    }
  }

}
</script>
<style>
.container {
  margin: 5 auto;
  min-height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
}
</style>